<template>
  <div class="package-detail">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="goPackageManage">套餐管理/</span>查看套餐
      </template>
      <template v-slot:content>
        <div class="package-detail-main">
          <div class="package-title">套餐名称：{{title}}</div>
          <div class="table-img" ref="steps">
            <el-table :data="tableData" :span-method="objectSpanMethod">
              <el-table-column label="商品图片" width="100">
                <template slot-scope="scope">
                  <el-image class="img" :src="scope.row.img" lazy></el-image>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="商品名称">
                <template slot-scope="scope">
                  <p class="name" :title="scope.row.name">{{ scope.row.name }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="specifications" label="规格"></el-table-column>
              <el-table-column prop="price" label="市场价"></el-table-column>
              <el-table-column prop="number" label="数量" width="100"></el-table-column>
              <el-table-column prop="status" label="是否显示套餐">
                <template slot-scope="scope">
                  <el-checkbox disabled v-model="scope.row.status"></el-checkbox>
                </template>
              </el-table-column>
              <!-- <el-table-column label="总金额" class="border">
                <template>
                  <p>{{ totlePrice }}</p>
                </template>
              </el-table-column> -->
              <el-table-column prop="discountAmount" label="优惠金额">
                <template slot-scope="scope">
                  <p>{{ scope.row.discountAmount }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="totlePrice" label="套餐价">
                <template>
                  <p>{{ packagePrice }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="touristPrice" label="游客价增量">
                <template>
                  <p>{{ touristPrice }}</p>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="bottom">
            <div class="operations" ref="operations">
              <el-button class="btn-white" @click="goPackageManage">返回</el-button>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import DBMarketing from 'models/db/marketing.js';
const dbMarketing = new DBMarketing();
export default {
  data() {
    return {
      title: '',
      tableData: [
        // {
        //   id: 12,
        //   img:
        //     "http://img3.imgtn.bdimg.com/it/u=3864086826,2415830551&fm=26&gp=0.jpg",
        //   name:
        //     "哈哈哈哈哈哈哈哈哈哈或或或或或或或或或或或或或或哈哈哈哈哈哈哈哈",
        //   price: 1234,
        //   number: 1,
        //   specifications: "kkkkkk",
        //   status: true
        // }
      ],
      totlePrice: 0,
      packagePrice: 0,
      touristPrice: 0,
    };
  },
  components: {
    SecondMenuLinkContent
  },
  beforeMount() {
    let id = this.$route.query.id;
    this.getData(id);
  },
  mounted() {
    const paddingWidth = 48;
    this.$refs.operations.style.width =
      this.$refs.steps.clientWidth + paddingWidth + 'px';
    window.onresize = () => {
      if (this.$refs.operations) {
        this.$refs.operations.style.width =
          this.$refs.steps.clientWidth + paddingWidth + 'px';
      }
    };
  },
  methods: {
    // 返回上一页
    goPackageManage() {
      this.$router.push('/admin/marketing/package-index/package-manage');
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 7 || columnIndex === 8) {
        let length = this.tableData.length;
        if (rowIndex % length === 0) {
          return {
            rowspan: length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 获取当前数据
    getData(id) {
      dbMarketing.getDBDetailPackage(id).then(res => {
        if (res.success) {
          this.totlePrice = res.result.setMeal.oldPrice;
          this.packagePrice = res.result.setMeal.price;
          this.touristPrice = res.result.setMeal.visitorIncrement;
          this.title = res.result.setMeal.title;
          let arr = [];
          res.result.setMealGoodsList.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.img = value.goodsPic;
            obj.name = value.goodsName;
            obj.price = value.marketPrice;
            obj.number = value.quantity;
            obj.status = value.isShow === 1;
            obj.discountAmount = value.discountedPrice
            let str = '';
            Object.keys(JSON.parse(value.itemTitle)).forEach(function(key) {
              console.log();
              str += JSON.parse(value.itemTitle)[key] + ';';
            });
            obj.specifications = str.slice(0, str.length - 1);

            arr.push(obj);
          });
          this.tableData = arr;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.package-detail {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .package-title {
    padding: 0 0 16px 20px;
    line-height: 16px;
    font-size: 14px;
  }
  .bottom {
    height: 40px;
    .operations {
      z-index: 10000;
      height: 60px;
      position: fixed;
      left: 256px;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
      .el-button {
        width: 96px;
        letter-spacing: 4px;
      }
      .el-button + .el-button {
        margin-left: 24px;
      }
    }
  }
}
</style>
<style lang="scss">
.package-detail {
  .el-table {
    .el-table__row {
      td:nth-child(7) {
        border-right: 1px solid #f2f6fc;
      }
    }
    .el-table__row:first-child {
      td:nth-child(8) {
        border-right: 1px solid #f2f6fc;
      }
    }
  }
}
</style>
